import { TextField, Theme } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { makeStyles } from 'tss-react/mui';

export const OtherDepositDescription = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const otherDepositDescription = 'otherDepositDescription';
  const otherDepositDescriptionWatch: string | null | undefined = useWatch({ name: 'otherDepositDescription' });
  const { t } = useTranslation();
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();
  const useStyles = makeStyles()((theme: Theme) => ({
    textField: {
      '& .MuiFilledInput-root': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
      '& .MuiFilledInput-root:hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
        '@media (hover: none)': {
          backgroundColor: 'rgba(0,0,0,0.04)',
        },
      },
      '& .MuiFilledInput-root.Mui-disabled': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
      '& .MuiFilledInput-root.Mui-disabled:before': {
        borderBottomStyle: 'solid',
      },
      '& .MuiFilledInput-root:hover.Mui-disabled:before': {
        borderBottom: '1px solid gray !important',
      },
      '& .MuiFilledInput-input': {
        cursor: 'default',
      },
      '& .MuiFilledInput-input.Mui-disabled': {
        WebkitTextFillColor: '#202020',
      },
      '& .MuiInputLabel-root': {
        color: 'rgba(0, 0, 0, 0.6)',
      },
    },
    characterIndication: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
  }));
  const { classes } = useStyles();

  useEffect(() => {
    if (!getValues(otherDepositDescription)) {
      setValue(otherDepositDescription, '');
    }

    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);
  return (
    <Controller
      control={control}
      name={otherDepositDescription}
      rules={{
        maxLength: { value: 255, message: 'notification.createTask.maxLimitLabel' },
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <>
          <TextField
            className={classes.textField}
            multiline
            fullWidth
            maxRows={5}
            id="otherDepositDescription"
            variant="filled"
            color="primary"
            autoComplete="off"
            label={t('placement.placementMods.otherDepositDescription')}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit || isSaveModApiCalling ? 'auto' : 'none',
              },
            }}
            onChange={e => {
              if (e.target.value?.length <= 255) {
                setValue(otherDepositDescription, e.target.value);
                onChange(e.target.value);
              }
            }}
            disabled={isSaveModApiCalling}
            value={getValues(otherDepositDescription) ?? ''}
            {...rest}
          />
          <div className={classes.characterIndication}>
            <span style={{ color: '#707070' }}>
              {`${otherDepositDescriptionWatch ? otherDepositDescriptionWatch?.length.toLocaleString() : 0}/255`}
            </span>
          </div>
        </>
      )}
    />
  );
};
